'use strict';

require('./flatten-a717674f.js');
require('./variadic.js');
var isArray = require('./isArray-fff5bad6.js');
var head = require('./head.js');
var tail = require('./tail.js');
var copy = require('./copy.js');
var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-ad34ecfb.js');

function set_(ks, v, o) {
  var k = head(ks);

  if (ks.length > 1) {
    v = set_(tail(ks), v, o[k] || {});
  }

  return copy(o, _rollupPluginBabelHelpers._defineProperty({}, k, v));
}

function set(ks, v, o) {
  ks = isArray.isArray(ks) ? ks : ks.toString().split('.');
  return set_(ks, v, o);
}

module.exports = set;
